import React, { PureComponent } from 'react';
import { formatText } from '../../common/index.js';
import FundCard from '../FundCard/FundCard.js';
import './FundFrame.css';
import i18n from '../../i18n.js';

class FundFrame extends PureComponent {

    static defaultProps = {
        funds: null,
        params: null,
    };

    render() {

        const {
            params,
            funds,
        } = this.props;
    
        const fundCards = funds.map(fund => {
            return (
                <FundCard
                    fund={fund}
                    params={params}
                    key={`${fund.ticker}`}
                />
            );
        });

        const fundFootnotes =
            <div className='fund-frame-footnotes'>

                { funds && funds[0] && funds[0].bottomDisclosure ? 
                    <div className='fund-frame-footnote' dangerouslySetInnerHTML={
                        {__html: formatText(funds[0].bottomDisclosure)}
                    }></div> : null }
                <div className='fund-frame-footnote'>{formatText(i18n.t('perf-footnote'))}</div>
                <div className='fund-frame-footnote'>{formatText(i18n.t('div-yield-footnote'))}</div>
                <div className='fund-frame-footnote'>{formatText(i18n.t('sec-yield-footnote'))}</div>
                <div className='fund-frame-footnote'>{formatText(i18n.t('expense-ratio-footnote'))}</div>
            </div>;

        return (
            funds ?
                <div className="fund-frame">

                    <div className="fund-cards" id='fund-cards'>
                        {fundCards}
                    </div>

                    {fundFootnotes}

                </div>
                : null
        );


    }
}

export default (FundFrame);
